<template>
    <div id="questionnaireDetail" class="page">
        <div class="second-header-wrap">
            <el-button type="default" @click="$router.back()" size="medium">返回</el-button>
            <el-button @click.native="jumpToPage('templateEdit', {id})" type="primary" v-if="isSelectedYearCurrent" size="medium">编辑</el-button>
            <el-button @click.native="jumpToPage('templateAdd', {id})" type="primary" size="medium">复制</el-button>
            <el-button @click="print()" type="primary" size="medium">打印</el-button>
        </div>
        <div class="questionnaire-container" ref="print" id="print">
            <div class="questionnaire-title">{{voteTitle}}</div>

            <div class="questionnaire-content">
                <template v-for="(questionItem, questionIndex) in topicList">
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 1"
                        class="question-item quetion-item--single-choice"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            <el-tag type="primary">单选</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.isHaveToDo === 0" type="primary">必做</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.selectedMax !== 0" type="primary">限选{{questionItem.selectedMax}}</el-tag>
                        </div>
                        <div class="question-item__choice" v-for="(optionItem, optionIndex) in questionItem.optionList">
                            <el-checkbox :true-label="1" :false-label="0" :value="optionItem.isHaveReason" :label="optionItem.optionTitle" />
                        </div>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 14"
                        class="question-item quetion-item--multiple-choice"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            <el-tag type="primary">单项填空</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.isHaveToDo === 0" type="primary">必做</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.selectedMax !== 0" type="primary">限选{{questionItem.selectedMax}}</el-tag>
                        </div>
                        <div class="question-item__choice" v-for="(optionItem, optionIndex) in questionItem.optionList">
                            <el-checkbox :true-label="1" :false-label="0" :value="optionItem.isHaveReason">
                                <span v-html="parseFillblank(optionItem.optionTitle)"></span>
                            </el-checkbox>
                        </div>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 2"
                        class="question-item quetion-item--multiple-choice"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            <el-tag type="primary">多选</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.isHaveToDo === 0" type="primary">必做</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.selectedMax !== 0" type="primary">限选{{questionItem.selectedMax}}</el-tag>
                        </div>
                        <div class="question-item__choice" v-for="(optionItem, optionIndex) in questionItem.optionList">
                            <el-checkbox :true-label="1" :false-label="0" :value="optionItem.isHaveReason" :label="optionItem.optionTitle" />
                        </div>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 21"
                        class="question-item quetion-item--multiple-choice"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            <el-tag type="primary">多项填空</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.isHaveToDo === 0" type="primary">必做</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.selectedMax !== 0" type="primary">限选{{questionItem.selectedMax}}</el-tag>
                        </div>
                        <div class="question-item__choice" v-for="(optionItem, optionIndex) in questionItem.optionList">
                            <el-checkbox :true-label="1" :false-label="0" :value="optionItem.isHaveReason">
                                <span v-html="parseFillblank(optionItem.optionTitle)"></span>
                            </el-checkbox>
                        </div>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 3"
                        class="question-item quetion-item--pic-multiple-choice"
                    >
                        <div class="question-item__title">{{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            <el-tag type="primary">单选</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.isHaveToDo === 0" type="primary">必做</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.selectedMax !== 0" type="primary">限选{{questionItem.selectedMax}}</el-tag>
                        </div>
                        <image-previewer tag="richtext" viewclass="question-item__choice-pic" :images="questionItem.picList">
                            <div class="question-item__choice" v-for="(optionItem, optionIndex) in questionItem.optionList">
                                <div class="question-item__choice-pic" :style="{backgroundImage: `url(${optionItem.optionPicUrl})`}"></div>
                                <div><el-checkbox :true-label="1" :false-label="0" :value="optionItem.isHaveReason" :label="optionItem.optionTitle" /></div>
                            </div>
                        </image-previewer>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 4"
                        class="question-item quetion-item--pic-multiple-choice"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            <el-tag type="primary">多选</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.isHaveToDo === 0" type="primary">必做</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.selectedMax !== 0" type="primary">限选{{questionItem.selectedMax}}</el-tag>
                        </div>
                        <image-previewer tag="richtext" viewclass="question-item__choice-pic" :images="questionItem.picList">
                            <div class="question-item__choice" v-for="(optionItem, optionIndex) in questionItem.optionList">
                                <div class="question-item__choice-pic" :style="{backgroundImage: `url(${optionItem.optionPicUrl})`}"></div>
                                <div><el-checkbox :true-label="1" :false-label="0" :value="optionItem.isHaveReason" :label="optionItem.optionTitle" /></div>
                            </div>
                        </image-previewer>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 5"
                        class="question-item question-item--qna"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            <el-tag type="primary">简答</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.isHaveToDo === 0" type="primary">必做</el-tag>&nbsp;&nbsp;
                        </div>
                        <div class="question-item__answer-area">
                            <el-input type="textarea" :rows="5" :disabled="true"></el-input>
                        </div>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 6"
                        class="question-item question-item--fill-blank"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicSeq}}、<span v-html="parseFillblank(questionItem.topicTitle)"></span>
                            <el-tag type="primary">填空</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.isHaveToDo === 0" type="primary">必做</el-tag>&nbsp;&nbsp;
                        </div>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 7"
                        class="question-item question-item--fill-label"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicTitle}}
                        </div>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 8"
                        class="question-item question-item--fill-label"
                    >
                        <div class="divider"></div>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 9"
                        class="question-item question-item--address"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            <el-tag type="primary">地址</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.isHaveToDo === 0" type="primary">必做</el-tag>&nbsp;&nbsp;
                        </div>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 10"
                        class="question-item quetion-item--pic-single-uploader"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            <el-tag type="primary">单张图片上传</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.isHaveToDo === 0" type="primary">必做</el-tag>&nbsp;&nbsp;
                        </div>
                        <div>
                            <el-upload
                                :action="`${ basePath }common/addImageUp`"
                                class="logo-uploader"
                                :disabled="true"
                            >
                                <div class="upload-hint"></div>
                            </el-upload>
                        </div>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 11"
                        class="question-item quetion-item--pic-multiple-uploader"
                    >
                        <div class="question-item__title">
                            {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            <el-tag type="primary">多张图片上传</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.isHaveToDo === 0" type="primary">必做</el-tag>&nbsp;&nbsp;
                        </div>
                        <div>
                            <el-upload
                                :action="`${ basePath }common/addImageUp`"
                                class="logo-uploader"
                                :disabled="true"
                            >
                                <div class="upload-hint"></div>
                            </el-upload>
                        </div>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 12"
                        class="question-item quetion-item--rate"
                    >
                        <div class="question-item__title">{{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            <el-tag type="primary">评分</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.isHaveToDo === 0" type="primary">必做</el-tag>&nbsp;&nbsp;
                        </div>
                        <div>
                            <el-rate></el-rate>
                        </div>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 15"
                        class="question-item quetion-item--rate"
                    >
                        <div class="question-item__title">{{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            <el-tag type="primary">手机号</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.isHaveToDo === 0" type="primary">必做</el-tag>&nbsp;&nbsp;
                        </div>
                        <div>
                            <el-input type="text" readonly="readonly" :value="''">
                            </el-input>
                        </div>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 16"
                        class="question-item quetion-item--rate"
                    >
                        <div class="question-item__title">{{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            <el-tag type="primary">邮箱</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.isHaveToDo === 0" type="primary">必做</el-tag>&nbsp;&nbsp;
                        </div>
                        <div>
                            <el-input type="text" readonly="readonly" :value="''">
                            </el-input>
                        </div>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 17"
                        class="question-item quetion-item--rate"
                    >
                        <div class="question-item__title">{{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            <el-tag type="primary">身份证</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.isHaveToDo === 0" type="primary">必做</el-tag>&nbsp;&nbsp;
                        </div>
                        <div>
                            <el-input type="text" readonly="readonly" :value="''">
                            </el-input>
                        </div>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 18"
                        class="question-item quetion-item--rate"
                    >
                        <div class="question-item__title">{{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            <el-tag type="primary">日期</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.isHaveToDo === 0" type="primary">必做</el-tag>&nbsp;&nbsp;
                        </div>
                        <div>
                            <el-input type="text" readonly="readonly" :value="''">
                            </el-input>
                        </div>
                    </div>
                    <div
                        :key="questionIndex" v-if="questionItem.topType === 19"
                        class="question-item quetion-item--rate"
                    >
                        <div class="question-item__title">{{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            <el-tag type="primary">时间</el-tag>&nbsp;&nbsp;
                            <el-tag v-if="questionItem.isHaveToDo === 0" type="primary">必做</el-tag>&nbsp;&nbsp;
                        </div>
                        <div>
                            <el-input type="text" readonly="readonly" :value="''">
                            </el-input>
                        </div>
                    </div>
                </template>

            </div>
        </div>
    </div>
</template>

<script>
    import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer.vue';
    import baseMixin from '@/mixins/baseMixin';
    import moment from 'moment';
    import {getVoteTwoById} from '@/api/setting';
    import {mapGetters} from 'vuex';

    export default {
        name: "questionnaireDetail",
        data: function() {
            return {
                expriyDate: '',
                id: this.$route.query.id,
                voteTitle: '',
                voteDesc: '',
                sendUserType: null,
                anonymous: null,
                topicList: [],
                voteStatus: null,
                isShowResult: null,
                maxVoteCount: 0,
                stuDepartJson: '{}',
                stuDepart: [],
                thScopeJson: '{}',
                thScope: {},
                teacherAddressData: {},
                studentAddressData: {},

                teacherAddressConfigData: {
                    title: '请选择老师',
                    depart: {target: 'all', departType: 't', userTypes: '1'},
                    group: true
                },
                studentAddressConfigData: {
                    title: '请选择学生班级',
                    depart: {target: 'depart', departType: 's', userTypes: '2'}
                }
            }
        },
        mixins: [baseMixin],
        computed: {
            ...mapGetters(['isSelectedYearCurrent']),
        },
        components: {
            ImagePreviewer,
        },
        created() {
            getVoteTwoById({
                voteId: this.id
            })
                .then(res => res.data)
                .then(data => {
                    const pageData = data.data;
                    pageData.topicList.forEach(item => {
                        if (item.topType === 4 || item.topType === 3) {
                            item.picList = item.optionList.map(item => ({src: item.optionPicUrl}));
                        }
                    });
                    this.voteTitle = pageData.voteTitle;
                    this.voteDesc = pageData.voteDesc;
                    this.sendUserType = pageData.sendUserType;
                    this.expriyDate = pageData.expriyDate;
                    this.anonymous = pageData.anonymous;
                    this.topicList = pageData.topicList;
                    this.stuDepartJson = pageData.stuDepartJson;
                    this.stuDepart = JSON.parse(pageData.stuDepartJson);
                    this.thScopeJson = pageData.thScopeJson;
                    this.thScope = JSON.parse(pageData.thScopeJson);
                    this.voteStatus = pageData.voteStatus;
                    this.isShowResult = pageData.isShowResult;
                    this.maxVoteCount = pageData.maxVoteCount;

                    if(pageData.sendUserType === 1) {
                        const thScope = JSON.parse(pageData.thScopeJson);

                        this.teacherAddressData = {
                            userJson: [],
                            departJson: [],
                            groupJson: []
                        };
                    } else {
                        this.studentAddressData = {
                            userJson: [],
                            departJson: [],
                            groupJson: []
                        }
                    }
                });
        },
        methods: {
            print() {
                this.$print(this.$refs.print);
            },
            parseFillblank(title) {
                return title.replace(/{(\d+?)}/g, function(_, num) {
                    return `<input disabled type="text" class="blank" maxlength="${num}" style="width: ${num * 20}px" />`
                });
            },
            updateExpriyDate() {
                if(!this.expriyDate) {
                    this.$message.error('请填写截止日期！');
                } else {
                    updateVoteTwoExpriyDate({
                        expriyDate: moment(this.expriyDate).format('YYYY-MM-DD'),
                        id: this.id
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                const _this = this;
                                this.$message({
                                    message: '修改结束日期成功',
                                    type: 'success',
                                    duration: 1000,
                                    onClose: function () {
                                        _this.$router.back();
                                    }
                                });
                            }
                        })
                }

            },
            questionnairePublish() {
                const formData = {
                    anonymous: this.anonymous,
                    expriyDate: moment(this.expriyDate).format('YYYY-MM-DD'),
                    id: this.id,
                    isShowResult: this.isShowResult,
                    maxVoteCount: this.maxVoteCount,
                    sendUserType: this.sendUserType,
                    stuDepartJson: this.stuDepartJson,
                    thScopeJson: this.thScopeJson,
                    topicList: this.topicList,
                    voteDesc: this.voteDesc,
                    voteStatus: 2,
                    voteTitle: this.voteTitle
                };

                updateVoteTwo(formData)
                    .then(res => res.data)
                    .then(data => {
                        if(data.result) {
                            const _this = this;

                            this.$message({
                                message: '发布成功',
                                type: 'success',
                                duration: 1000,
                                onClose: function () {
                                    _this.$router.back();
                                }
                            });
                        }
                    })
            },
            reissueQuestionnaire() {
                const teacherAddressData = {
                    userList: this.teacherAddressData.userJson || [],
                    departList: this.teacherAddressData.departJson || [],
                    groupList: this.teacherAddressData.groupJson || [],
                };

                againSendVote({
                    id: this.id,
                    sendUserType: this.sendUserType,
                    stuDepartJson: this.sendUserType === 2 ? this.studentAddressData.departJson : {},
                    thScopeJson: this.sendUserType === 1 ? teacherAddressData : {},
                })
                    .then(res => res.data)
                    .then(data => {
                        if(data.result) {
                            const _this = this;
                            this.$message({
                                message: '补发成功',
                                type: 'success',
                                duration: 1000,
                                onClose: function () {
                                    _this.$router.back();
                                }
                            });
                        }
                    })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../styles/mixin";

    .second-header-wrap {
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        background-color: #fff;
        z-index: 1000;
    }
    .questionnaire-container {
        border: 1px solid #DBDBDB;
        width: 1024px;
        margin: 10px auto 10px auto;
        box-sizing: border-box;
        padding: 10px 30px;

        & > * {
            margin: 10px 0;
        }
        .questionnaire-title {
            color: #4C4C4C;
            font-size: 22px;
            text-align: center;
        }
        .questionnaire-info {
            span {
                color: #55a1e3;
                margin: 0 5px;
            }
        }
        .questionnaire-content {
            overflow-y: auto;
            margin-top: 10px;
            border-top: 1px solid #DBDBDB;
            padding-top: 30px;
        }
        .question-item {
            @include clearfix;
            & > * {
                margin: 5px 0;
            }
            .question-item__type {
                font-size: 12px;
            }
            .question-item__choice-pic {
                @include cover-bg;
                @include wh(150px, 150px);
                margin-bottom: 5px;
            }
        }
        .quetion-item--pic-multiple-choice, .quetion-item--pic-multiple-choice {
            .question-item__choice {
                float: left;
                margin-right: 10px;
            }
        }
    }
    .blank {
        border: 0 !important;
        border-bottom: 1px solid #000 !important;
    }
    .divider {
        border: 1px solid #999;
    }
    .upload-hint {
        width: 160px;
        height: 190px;
        float: left;
        border: 1px solid #ccc;
        margin-right: 10px;
        margin-bottom: 10px;
        background: url(../../../assets/images/picinput.png) no-repeat;
        background-position: center center;
        cursor: pointer;
    }
    @media print {
        #content {
            width: 900px !important;
        }
        #content * {
            color: #000 !important;
        }
        .content {
            border: 0 !important;
        }
        .section-header__bottom-block {
            width: 250px !important;
        }
        .notify--not-print {
            display: none !important;
        }
        #print_div {
            display: block;
        }
        .header {
            font-size: 34px !important;
        }
        .section--verify-info .info-item__label span {
            width: 80px !important;
        }
        * {
            -webkit-print-color-adjust: exact;
        }
        .section-header__bottom-block {
            background-color: #409EFF !important;
            color: #fff !important;
        }
        .sub-section__title {
        }
        .icon {
            width: 30px !important;
            height: 30px !important;
            display: inline-block !important;
            vertical-align: middle !important;
            background: no-repeat center center / cover !important;
        }
        .icon--record {
            background-image: url(../../../assets/images/primary/icon-record2.png) !important;
        }
        .icon--score {
            background-image: url(../../../assets/images/primary/icon-score.png) !important;
        }
        .icon--honor {
            background-image: url(../../../assets/images/primary/icon-honor.png) !important;
        }
        .icon--duty {
            background-image: url(../../../assets/images/primary/icon-duty.png) !important;
        }
        .icon--prize {
            background-image: url(../../../assets/images/primary/icon-prize.png) !important;
        }
        .icon--sport {
            background-image: url(../../../assets/images/primary/icon-sport.png) !important;
        }

        #print_div .section-body__right-block {
            width: 500px !important;
        }
        #print_div .section-body__right-block .student-info-item__value {
            width: 310px !important;
        }
        #print_div .info-item__value {
            width: 560px !important;
        }
        #print_div .student-info-item__label, #print_div .student-info-item__value {
            font-size: 20px;
        }
        #print_div .info-item > * {
            font-size: 20px;
        }

        .printRemindMsg {
            display: block;
        }
        .remindMsg {
            display: none;
        }
    }
</style>
<style>
    #questionnaireDetail .el-checkbox__label {
        white-space: normal;
    }
</style>



// WEBPACK FOOTER //
// src/views/kindergarten/setting/TemplateDetail.vue